export const C = {
  bg: '#060d18', panel: '#0f1923', card: '#0a1120',
  border: '#1e3a5f', borderSoft: '#334155',
  text: '#e2e8f0', body: '#cbd5e1', muted: '#94a3b8', faint: '#64748b',
  crimson: '#f43f5e', info: '#38bdf8', green: '#4ade80',
};

export const CALENDLY_URL = 'https://calendly.com/peterh-crimsonscan/30min';

export const container = { width: '100%', maxWidth: 1080, margin: '0 auto', padding: '0 24px' };

export const sectionH2 = { color: C.text, fontWeight: 700, fontSize: '1.7rem', marginBottom: 12 };

export const sectionSub = { color: C.muted, fontSize: 15, lineHeight: 1.7, maxWidth: 640 };

export const primaryBtnStyle = {
  background: C.crimson, border: 'none', borderRadius: 8, color: '#fff',
  fontWeight: 700, fontSize: 15, padding: '13px 30px', cursor: 'pointer',
  textDecoration: 'none', display: 'inline-block',
};

export const ghostBtnStyle = {
  background: 'transparent', border: `1px solid ${C.borderSoft}`, borderRadius: 8,
  color: C.body, fontWeight: 600, fontSize: 15, padding: '13px 30px',
  cursor: 'pointer', textDecoration: 'none', display: 'inline-block',
};
